// src/AuthWrapper.jsx
import React from "react";
import { Authenticator } from "@aws-amplify/ui-react";
import { BrowserRouter } from "react-router-dom";
import App from "../../App.react";

function AuthWrapper() {
    return (
        <Authenticator
            components={{
                Header() {
                    return (
                        <div style={{ textAlign: "center", padding: "20px" }}>
                            <img
                                src="/logo512.png"
                                alt="My Logo"
                                style={{ width: 130, marginBottom: 60 }}
                            />
                        </div>
                    );
                },
                Footer() {
                    return (
                        <div style={{
                            position: "fixed",
                            bottom: 0,
                            left: 0,
                            width: "100%",
                            textAlign: "center",
                            padding: "16px 0",
                            fontSize: "12px",
                            color: "#888",
                            background: "transparent",
                        }}>
                            <div>comet.livecaps@gmail.com</div>
                            <div>© 2022 COMET SYSTEMS CO. ALL RIGHTS RESERVED</div>
                        </div>
                    );
                }
            }}
        >
            {({ signOut, user }) => (
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            )}
        </Authenticator>
    );
}

export default AuthWrapper;